export enum PublicCollectionTab {
  Content = 0,
  Assets = 1,
}

export const publicCollectionTabLabels: Record<PublicCollectionTab, string> = {
  [PublicCollectionTab.Content]: 'Content',
  [PublicCollectionTab.Assets]: 'Assets',
};

export const publicCollectionTabs: PublicCollectionTab[] = [
  PublicCollectionTab.Content,
  PublicCollectionTab.Assets,
];
